__webpack_require__.p = "https://bi-central.accounting.amazon.dev/";